import { Action, Store } from '@reduxjs/toolkit';

import { logOut } from './actions/authenticationActions';
import { pGetCurrentSession } from './connections/authenticationConnection';
import { setLogOutReason } from './logOutReason';
import { getJwtTokenData, getLoggedInUser, isExemptFromSessionLimitation } from './selectors/users';
import { LoginDataSliceState } from './store/logInDataSlice';

const CHECK_SESSION_INTERVAL = 10000;
const AUTO_LOGOUT_MESSAGE = 'You logged in on another machine.';

export function initializeLoginTools(store: Store<LoginDataSliceState, Action>) {
  setTimeout(async () => {
    await checkForMultipleSessions(store);
  }, CHECK_SESSION_INTERVAL);
}

async function checkForMultipleSessions(store: Store<LoginDataSliceState, Action>) {
  try {
    const loggedInUser = getLoggedInUser(store.getState());
    if (loggedInUser == null || loggedInUser.customClaims?.loggedInWithLink) {
      return;
    }

    let currentSession;
    try {
      currentSession = await pGetCurrentSession();
    } catch {
      console.error('Failed to get current session');
      return;
    }

    if (!currentSession || isExemptFromSessionLimitation(store.getState())) return;

    const jwtToken = getJwtTokenData(store.getState());
    if (jwtToken?.session && jwtToken.session !== currentSession.token) {
      setLogOutReason(AUTO_LOGOUT_MESSAGE);
      store.dispatch(logOut() as any);
    }
  } finally {
    // Repeatedly call setTimeout instead of using setInterval to prevent overlap in case an API call takes too long.
    setTimeout(async () => {
      await checkForMultipleSessions(store);
    }, CHECK_SESSION_INTERVAL);
  }
}
